<template>
  <div class="track-list pa1 pb3-ns pt3-ns ph5-l ph3-m"
       :class="{'overflow-y-scroll' : withPagination}"
       v-infinite-scroll="nextPage"
       infinite-scroll-immediate-check="false"
       infinite-scroll-distance="50"
       infinite-scroll-disabled="disablePagination">
    <div class="track-list-header h2 w-95 mb1 textColor">
      <p class="fl w-30 h-100 pa1 pl4 ma0 text-ellipsis center-content b textColor">{{ $t("tracks.headers.title") }}</p>
      <p class="fl w-20 h-100 pa1 pl4 ma0 text-ellipsis center-content b textColor artist-mobile">{{ $t("tracks.headers.artist") }}</p>
      <p class="released fl w-15 h-100 pa1 ma0 center-content b textColor display-mobile">{{ $t("tracks.headers.duration") }}</p>
      <p class="fl w-20 h-100 pa1 pl3 ma0 text-ellipsis center-content b textColor display-mobile">{{ $t("tracks.headers.date") }}</p>
    </div>
    <div v-show="loading" class="flex justify-center items-center w-100">
      <clip-loader :loading="loading" :color="color" :size="size2"></clip-loader>
    </div>
    <div v-show="!loading && purchasedTracks.length === 0" class="flex justify-center items-center w-100 pt2 textColor">
      {{ $t("app.info.noResults") }}
    </div>
    <div v-show="purchasedTracks && !loading" class="track-container relative mb2" v-for="purchase in purchasedTracks"
         :track-by="purchase.id"
         :key="purchase.id">
      <track-download-item-list :purchase="purchase" class="item-container"></track-download-item-list>
    </div>
    <div v-show="withPagination && noMoreResults" class="flex justify-center items-center w-100 pt2 pb2 textColor">
      {{ $t("app.info.noMoreResults") }}
    </div>
    <div v-show="withPagination && loadingMore" class="flex justify-center items-center w-100">
      <clip-loader :loading="loadingMore" :color="color" :size="size2"></clip-loader>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import TrackDownloadItemList from './TrackDownloadItemList.vue'
  import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
  import infiniteScroll from 'vue-infinite-scroll'

  export default {
    name: 'track-download',
    props: {
      purchasedTracks: {
        required: true
      },
      withFilters: {
        default: true
      },
      withPagination: {
        default: true
      },
      loading: {
        required: true
      }
    },
    components: {
      ClipLoader,
      TrackDownloadItemList
    },
    directives: {infiniteScroll},
    data () {
      return {
        color: '#808080',
        size1: '100px',
        size2: '30px',
        disablePagination: false
      }
    },
    created () {
      this.disablePagination = !this.withPagination
      if (this.withFilters) {
        this.getGenres()
        this.setGenreFilter('')
      }
    },
    methods: {
      ...mapActions('track', [
        'getGenres',
        'setGenreFilter',
        'getAll',
        'loadMore',
        'setFrom'
      ]),
      ...mapActions('player', [
        'setPlaylist'
      ]),
      selectGenre (id) {
        if (this.withFilters && id !== this.genreFilter) {
          this.setGenreFilter(id)
          this.setFrom(0)
          this.getAll().catch((e) => {
            this.$toasted.show(this.error.message, {type: 'error'})
          })
        }
      },
      nextPage () {
        if (this.withPagination && !this.loadingMore && !this.noMoreResults) {
          this.loadMore()
        }
      }
    },
    computed: {
      ...mapGetters('player', [
        'currentTrack'
      ]),
      ...mapGetters('track', [
        'allTracks',
        'genres',
        'genreFilter',
        'noMoreResults'
      ]),
      loadingMore () {
        return this.$loading.isLoading('tarck loadMore')
      },
      loadingGenres () {
        return this.$loading.isLoading('track getGenres')
      }
    }
  }
</script>

<style scoped lang="scss">
  @import '~@/variables.scss';

  .track-playing {
    background-color: $primary-color !important;
  }

  .track-list {
    max-height: $main-height;
    height: min-content;
  }

  .genre-filter {
    -webkit-user-select: none; /* Safari 3.1+ */
    -moz-user-select: none; /* Firefox 2+ */
    -ms-user-select: none; /* IE 10+ */
    user-select: none; /* Standard syntax */
  }

  .genre-filter-selected {
    background-color: darkgray;
    color: black;
  }

  @media (min-width: 769px) {
    .item-container :hover {
      background-color: $primary-color;
    }
    .item-container {
      height: 3rem;
    }
  }

  @media (min-width: 1441px) {
    .track-list {
      padding-left: 10rem;
      padding-right: 10rem;
    }
  }

  @media (max-width: 768px) {
    .track-list-header {
      display: flex;
    }
    .track-list {
      display: flex;
      flex-wrap: wrap;
    }
    .track-container {
      height: 6rem;
      width: 45%;
      margin: 2.5%;
    }
    .genre-filter {
      padding: 4px;
    }
    .artist-mobile {
      width: 75px;
    }
    .display-mobile {
      display: none;
    }
  }

  @media (max-width: 600px) {
    .track-container {
      width: 95%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/tracks/TrackDownload.vue